import api from "@/api";
import { PaginationModel } from "../types";

export default class ConfirmApi {
  static async list(
    options:
      | {
          filter?: {
            role?: string[];
          };
        }
      | PaginationModel
  ) {
    return await api.get(`gene/apply/list`, options);
  }

  static async status(memberCode:any, status:any) {
    return await api.post(`gene/apply/changeGeneStatus/${memberCode}/${status}`);
  }

  static async geneInfo(type?: string){
    return await api.get(`gene/info/infoList/${type}`);
  }

  static async save(memberCode?: any, list?:any ) {
    return await api.post(`gene/result/insert/${memberCode}`,list);
  }

  static async result(memberCode?: any) {
    return await api.get(`gene/result/member/${memberCode}`);
  }
}
